import { schema } from 'normalizr'
import store from '@/store'

export default new schema.Entity(
    'devices',
    {},
    {
        processStrategy: device => ({
            // Meta
            _type: 'device',
            // Fields
            _position: () => store.getters.positions[device.id],
            ...device,
        }),
    }
)
